<template>
	<!-- <div class="inline"> -->
		<el-form-item :label="label" :prop='"itemMap."+prop+".value"' style="width:380px" :rules="rules">
			<el-input :type="prop+'.value'" v-model="val.value" :disabled='disabled' style="width:200px"></el-input>
			<template v-if='detail[0].valueUnit'>
				<span>{{detail[0].valueUnit}}</span>
			</template>
		</el-form-item>
	<!-- </div> -->
</template>
<script>

export default {
	name: 'inputCom',
	props: {
    val: {
      type: Object,
      default: function () {
				return {
					value:''
				}
			}
		},
		prop:{
			type: String,
      default: ''
		},
		label: {
			type: String,
      default: ''
		},
		unit:{
			type: String,
      default: ''
		},
		disabled:{
			type:Boolean,
			default: false
		},
		detail:{
			type: Array,
			default: function () {
        return [{
          itemResult:true,
					valueContentTooltip:"请输入内容",
					valueInput:true,
					valueRequired:false,
					valueType:"NUMERIC",
					valueUnit:''
        }]
      }
		},
		rules:{
			type: Array,
			default: function () {
				return[]
			}
		}
  },
	data () {
		return {
		}
	},
	computed: {
  },
	methods: {
	},
	created () {
		// console.log(this.detail)
		if(this.detail[0].valueRequired==true){
			var obj={}
			obj.required=true
			obj.message='请输入内容'
			this.rules.push(obj)
		}
		if((this.detail[0].valueType=="NUMERIC") || (this.detail[0].valueType=="INTEGER")){//数字类型
			// var obj={message: '输入内容必须为数字类型', type:'number'}
			var obj={}
			obj.trigger="blur"
			var reg = /\d/;
			obj.validator=(rule, value, callback) => {
				if(value&& isNaN(Number(value))){
					callback(new Error('输入内容必须为数字类型'));
				}else{
					callback()
				}
			}
			this.rules.push(obj)
			if(this.detail[0].valueMax||this.detail[0].valueMin){
				var obj1={}
				obj1.trigger="blur"
					obj1.validator=(rule, value, callback) => {
						if(value&&(value>this.detail[0].valueMax||value<this.detail[0].valueMin)){
							callback(new Error(this.detail[0].valueContentTooltip));
						}else{
							callback()
						}
					}
				this.rules.push(obj1)
			}
			if(this.detail[0].maxFractions>0){
				var obj1={}
				obj1.trigger="blur"
				obj1.validator=(rule, value, callback) => {
					var reg1 = new RegExp('^\\+?(\\d*\\.\\d{0,' + this.detail[0].maxFractions + '})$')
					if((value+"").indexOf('.')>0&&!reg1.test(value)) {
						callback(new Error('最多保留'+this.detail[0].maxFractions+'位小数'));
					}else{
						callback()
					}
				}
				this.rules.push(obj1)
			} else if ((!this.detail[0].maxFractions) && (this.detail[0].valueType=="INTEGER")) {
				var obj1={}
				obj1.trigger="blur"
				obj1.validator=(rule, value, callback) => {
					if((value+"").indexOf('.')>0) {
						callback(new Error('请输入正整数'));
					}else{
						callback()
					}
				}
				this.rules.push(obj1)
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/utils/inputCom.vue?5d6f6619